import React, { useState } from "react";
import { Card, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Spin } from "antd";
import toast from "react-hot-toast";
import { createMaterialList } from "../../services/materielApi";
import DownloadExcelModel from "./ExcelModel";
import FileUpload from "./FileUpload";
import ExcelJS from "exceljs";
import { stateLabels } from "../../pages/stocke";
import { useQueryClient } from "react-query";

const AddMaterielMass = ({ modal, setModal, toggle }) => {
  const [materielssData, setMaterielsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const queryClient = useQueryClient();

  const handleAcceptedFiles = (files) => {
    const file = files[0];

    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    });

    setSelectedFiles([file]);

    const reader = new FileReader();
    reader.onload = async (e) => {
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(e.target.result);

      const worksheet = workbook.worksheets[0];
      const materielss = [];

      worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
        if (rowNumber === 1) return;

        const stateLabel = row.getCell(6).value?.toString().trim();

        const name = row.getCell(1).value;
        const serialNumber = row.getCell(2).value;
        const nbMaterial = row.getCell(3).value;
        const unitPrice = row.getCell(4).value;
        const globalPrice = row.getCell(5).value;

        const state = Object.keys(stateLabels).find(
          key => stateLabels[key].toLowerCase() === stateLabel?.toLowerCase()
        );

        const couleur = row.getCell(7).value;
        const description = row.getCell(8).value;

        if (!state) {
          toast.error(`Ligne ${rowNumber}: L'état "${stateLabel}" est invalide.`);
          return;
        }

        if (!name || !nbMaterial || !unitPrice || !globalPrice) {
          toast.error(`Ligne ${rowNumber}: Veuillez remplir les champs obligatoires.`);
          return;
        }

        materielss.push({
          name,
          serialNumber,
          nbMaterial,
          unitPrice,
          globalPrice,
          state,
          couleur,
          description,
          status: "DISPONIBLE"
        });
      });

      if (materielss.length === 0) {
        toast.error("Aucune donnée valide à ajouter.");
      } else {
        setMaterielsData(materielss);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      console.log("materielssData", materielssData);
      await createMaterialList(materielssData);
      queryClient.invalidateQueries("materiels");
      toast.success(`${materielssData?.length} materiels ajoutés avec succès 🎉`);
      setModal(false);
    } catch (error) {
      toast.error("Erreur lors de l'ajout des matériels : " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={modal} toggle={toggle} centered backdrop={"static"} style={{ maxWidth: "800px" }}>
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        Ajout en masse des matériels par un fichier excel
      </ModalHeader>

      <form onSubmit={handleSubmit}>
        <ModalBody>
          <Row>
            <Col lg={6}>
              <DownloadExcelModel />
            </Col>
            <Col lg={6}>
              <FileUpload selectedFiles={selectedFiles} handleAcceptedFiles={handleAcceptedFiles} />
            </Col>
          </Row>
        </ModalBody>

        <ModalFooter>
          <Button color="light" onClick={() => setModal(false)}>
            Annuler
          </Button>

          <Button type="submit" className="btn btn-soft-success" disabled={isLoading || materielssData.length === 0}>
            {isLoading ? "Chargement..." : "Ajouter les matériels"}
            {isLoading && <Spin />}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default AddMaterielMass;
